export default __webpack_public_path__ + "static/media/fruit-480w.5ba21648.avif";